import { EvaluationFilterMeta } from '@src/main/modules/reports/ui/mapEvaluationFiltersToCriteria';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { useMemo } from 'react';

export const useEvaluationFilters = (
  startDate: Date | null,
  endDate: Date | null,
  includeEmployeeFields: 'commercial' | 'flight',
) =>
  useMemo<EvaluationFilterMeta>(() => {
    const baseFilters: EvaluationFilterMeta = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },

      carrierCode: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      flightNumber: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      departureAirport: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      arrivalAirport: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      aircraftRegistration: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      flightDate: {
        operator: FilterOperator.AND,
        constraints: [
          {
            value: [startDate ? new Date(startDate) : null, endDate ? new Date(endDate) : null],
            matchMode: FilterMatchMode.BETWEEN,
          },
        ],
      },
      receptionDate: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.BETWEEN }],
      },
    };

    // Add employee-specific fields based on evaluation type
    if (includeEmployeeFields === 'commercial') {
      baseFilters.supervisorEmployeeId = {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      };
      baseFilters.evaluatedEmployeeId = {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      };
    } else if (includeEmployeeFields === 'flight') {
      baseFilters.purserEmployeeId = {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      };
    }

    return baseFilters;
  }, [startDate, endDate, includeEmployeeFields]);
